import { render } from "./ClueCard.vue?vue&type=template&id=27a44316&scoped=true"
import script from "./ClueCard.vue?vue&type=script&lang=js"
export * from "./ClueCard.vue?vue&type=script&lang=js"

import "./ClueCard.vue?vue&type=style&index=0&id=27a44316&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a44316"]])

export default __exports__